import { ComponentProps } from 'react';
import { Button } from '../../../../design-system/button/button';
import { Stack } from '../../../../design-system/stack/stack';
import { exhaustiveCheck } from '../../../../utils/exhaustive-check';
import { PaymentFlowStepWrapper } from '../../components/payment-flow-step-wrapper';
import { InvoiceWarningCard } from './invoice-warning-card';

type VariantConfig =
  | {
      variant: Extract<ComponentProps<typeof InvoiceWarningCard>['variant'], 'VENDOR_COUNTRY_NOT_SUPPORTED'>;
      unsupportedVendorCountry?: string;
    }
  | {
      variant: Extract<ComponentProps<typeof InvoiceWarningCard>['variant'], 'CURRENCY_NOT_SUPPORTED'>;
      unsupportedCurrency?: string;
    }
  | {
      variant: Extract<ComponentProps<typeof InvoiceWarningCard>['variant'], 'GENERIC_ERROR'>;
    };

type UnsupportedInvoiceDetailsProps = {
  title: string;
  variantConfig: VariantConfig;
  onGoBack: () => void;
};

export const UnsupportedInvoiceDetails = ({ title, variantConfig, onGoBack }: UnsupportedInvoiceDetailsProps) => {
  const warningCardProps = getWarningCardProps(variantConfig);

  return (
    <PaymentFlowStepWrapper title={title} onGoBack={onGoBack}>
      <Stack space={3} align="stretch">
        <InvoiceWarningCard variant={variantConfig.variant} {...warningCardProps} />

        <Button onClick={onGoBack}>Upload a new invoice</Button>
      </Stack>
    </PaymentFlowStepWrapper>
  );
};

const getWarningCardProps = (variantConfig: VariantConfig) => {
  const { variant } = variantConfig;

  switch (variant) {
    case 'VENDOR_COUNTRY_NOT_SUPPORTED':
      return { unsupportedVendorCountry: variantConfig.unsupportedVendorCountry };
    case 'CURRENCY_NOT_SUPPORTED':
      return { unsupportedCurrency: variantConfig.unsupportedCurrency };
    case 'GENERIC_ERROR':
      return {};
    default:
      return exhaustiveCheck(variant);
  }
};
